import { Button, Typography } from '@mui/material'
import { CoreMyntModal } from 'components/modals/CoreMyntModal'

export const DeleteTemplateModal = ({ templateId, onCancel, onDeleteTemplate }) => {
  return (
    <CoreMyntModal
      open={!!templateId}
      title={'Delete template'}
      actions={(Wrapper) => (
        <Wrapper>
          <Button onClick={() => onDeleteTemplate(templateId)}>Ok</Button>
          <Button onClick={onCancel}>Cancel</Button>
        </Wrapper>
      )}
    >
      <Typography>Do you really want to delete template {templateId}?</Typography>
    </CoreMyntModal>
  )
}
